import React from 'react'
import { Button, Header, Image, Modal, Form, Input, Select } from 'semantic-ui-react'
import optionsLogin from '../options/login'

import MODEL from '../model/app'
import User from '../model/user'

function AskVersionModal() {
  const [open, setOpen] = React.useState(false)

  return (
    <Modal
      onClose={() => setOpen(false)}
      onOpen={() => setOpen(true)}
      open={true}
    >
      <Modal.Header>Would you like to continue working on your draft changes?</Modal.Header>
      <Modal.Content image scrolling>
        <Modal.Description>
            <p>You can either continue with your not-yet published changes or proceed with the currently published app content.</p>
        </Modal.Description>
      </Modal.Content>
      <Modal.Actions>
        <Button color='black' onClick={() => { User.getProject(false); setOpen(false) }}>
          Ignore draft changes
        </Button>
        <Button color='green' onClick={() => { User.getProject(true); setOpen(false) }}>
          Continue with draft changes
        </Button>
      </Modal.Actions>
    </Modal>
  )
}

export default AskVersionModal